export default __webpack_public_path__ + "static/bg_living_earth_texture-1db9cb632188a1aa1dd95afbdd51fbcd.jpg";